import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ToggleWrapper from '../ToggleWrapper';

const HamburgerMenuSection = ({ section, handleClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const isActive = path => window.location.pathname.startsWith(path);

  return (
    <div>
      {/* eslint-disable-next-line @department-of-veterans-affairs/prefer-button-component */}
      <button
        type="button"
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-controls={`nav-section-${section.TEST_ID}`}
        className={` nav__mobile-menu-btn is--section ${
          isOpen ? 'is--expanded' : ''
        } ${isActive(section.URL) && 'is--active'}`}
        data-testid={section.TEST_ID}
        onClick={toggleOpen}
      >
        {section.LABEL}
        {isOpen ? (
          <va-icon
            size="3"
            icon="remove"
            class="vads-u-color--white vads-u-margin-left--0p5"
          />
        ) : (
          <div>
            <va-icon
              size="3"
              icon="add"
              class="vads-u-color--white vads-u-margin-left--0p5"
            />
          </div>
        )}
      </button>
      <ul
        id={`nav-section-${section.TEST_ID}`}
        className={`nav__mobile-menu-subsection vads-u-margin--0 vads-u-padding-x--2 ${
          isOpen ? '' : 'vads-u-display--none'
        }`}
      >
        {section.LINKS.map((link, index) => {
          return (
            <ToggleWrapper
              toggleKey={link.FEATURE_FLAG_NAME}
              displayWhenDisabled={link.DISPLAY_WHEN_DISABLED}
              key={`hamburger-section-link-${index}`}
            >
              <li key={index}>
                <a
                  className={`nav__mobile-menu-sublinks vads-u-width--full ${
                    isActive(link.URL) && 'is--active'
                  }`}
                  href={link.URL}
                  data-testid={link.TEST_ID}
                  onClick={handleClick}
                  data-eventname="nav-link-click"
                >
                  {link.LABEL}
                  <va-icon
                    size="3"
                    icon="chevron_right"
                    class="vads-u-margin-left--0p5"
                  />
                </a>
              </li>
            </ToggleWrapper>
          );
        })}
      </ul>
    </div>
  );
};

HamburgerMenuSection.propTypes = {
  handleClick: PropTypes.func.isRequired,
  section: PropTypes.shape({
    LABEL: PropTypes.string.isRequired,
    URL: PropTypes.string,
    TEST_ID: PropTypes.string.isRequired,
    FEATURE_FLAG_NAME: PropTypes.string,
    LINKS: PropTypes.arrayOf(
      PropTypes.shape({
        LABEL: PropTypes.string.isRequired,
        URL: PropTypes.string.isRequired,
        TEST_ID: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
};

export default HamburgerMenuSection;
